//material ui
import { Card, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

//react admin
import { useTranslate } from 'react-admin';

//components
import CardDetails from './CardDetails';
//---//

const useStyles = makeStyles(() => ({
  root: {
    padding: '0px 16px 50px 16px',
    border: 'none',
  },
  subRoot: {
    boxShadow: '3px 3px 8px 0px #b5b5b5',
  },
  typography: {
    flexGrow: 1,
    textAlign: 'center',
  },
  headingTypography: {
    flexGrow: 1,
    textAlign: 'center',
    padding: '16px 0',
    marginTop: '0.35em',
    fontWeight: 600,
  },
}));

const Welcome = (props: any) => {
  const { dashboardData } = props;

  const translate = useTranslate();
  const classes = useStyles();
  return (
    <Card className={classes.root}>
      <Typography
        variant="h4"
        className={classes.headingTypography}
        gutterBottom
        component="div"
      >
        Dashboard
      </Typography>
      <Grid container spacing={6} alignItems="center" justifyContent="center">
        <Grid item xs={12} sm={4} md={3}>
          <CardDetails
            icon={'fa-solid:users'}
            title={'User Registrations'}
            subtitle={Number(dashboardData?.totalUsers || 0).toLocaleString()}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <CardDetails
            icon={'mdi:users'}
            title={translate('Total Profiles')}
            subtitle={Number(
              dashboardData?.totalProfiles || 0
            ).toLocaleString()}
          />
        </Grid>
      </Grid>
      <Grid container spacing={6} alignItems="center" justifyContent="center">
        <Grid item xs={12} sm={4} md={3}>
          <CardDetails
            icon={'mdi:calendar-check'}
            title={translate('Total Active Subscriptions')}
            subtitle={Number(
              dashboardData?.subscriptionCount || 0
            ).toLocaleString()}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <CardDetails
            icon={'mdi:currency-usd'}
            title={translate('Total Revenue')}
            subtitle={`$${(
              Number(dashboardData?.totalRevenew) || 0
            ).toLocaleString()}`}
          />
        </Grid>
      </Grid>
    </Card>
  );
};

export default Welcome;
